import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosFunerariumsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosFunerariumsController.php
* @route '/api/partner/enaos/funerariums'
*/
const GetEnaosFunerariumsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEnaosFunerariumsController.url(options),
    method: 'get',
})

GetEnaosFunerariumsController.definition = {
    methods: ["get","head"],
    url: '/api/partner/enaos/funerariums',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosFunerariumsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosFunerariumsController.php
* @route '/api/partner/enaos/funerariums'
*/
GetEnaosFunerariumsController.url = (options?: RouteQueryOptions) => {
    return GetEnaosFunerariumsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosFunerariumsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosFunerariumsController.php
* @route '/api/partner/enaos/funerariums'
*/
GetEnaosFunerariumsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetEnaosFunerariumsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHomePartner\GetEnaosFunerariumsController::__invoke
* @see app/Http/Controllers/FuneralHomePartner/GetEnaosFunerariumsController.php
* @route '/api/partner/enaos/funerariums'
*/
GetEnaosFunerariumsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetEnaosFunerariumsController.url(options),
    method: 'head',
})

export default GetEnaosFunerariumsController